export const SET_VIDEO_COMMENT = 'VIDEO_COMMENT/SET_VIDEO_COMMENT'
export const SET_VIDEO_COMMENTS = 'VIDEO_COMMENT/SET_VIDEO_COMMENTS'
